export const TITLE = "Editar usuario";
export const SUB_TITLE = "Ingrese los nuevos datos";
